/**
 * Epic Scheduling block.
 *
 * Tab behaviour for blocks configured with more than one scheduling tool.
 * Blocks with a single tool render no tablist and are skipped entirely.
 *
 * @package ardenthealth
 */

;(function () {
	'use strict'

	/**
	 * Wire up one block instance.
	 *
	 * @param {HTMLElement} block The block wrapper element.
	 */
	function initBlock(block) {
		var tabs = Array.prototype.slice.call(block.querySelectorAll('[data-ahms-tab]'))

		if (tabs.length < 2) {
			return
		}

		/**
		 * Select a tab and reveal its panel.
		 *
		 * @param {HTMLElement} tab        The tab to activate.
		 * @param {boolean}     moveFocus  Whether to move focus to it (keyboard nav).
		 */
		function activate(tab, moveFocus) {
			tabs.forEach(function (candidate) {
				var panel = document.getElementById(candidate.getAttribute('aria-controls'))
				var active = candidate === tab

				candidate.setAttribute('aria-selected', active ? 'true' : 'false')
				candidate.setAttribute('tabindex', active ? '0' : '-1')
				candidate.classList.toggle('is-active', active)

				if (!panel) {
					return
				}

				panel.hidden = !active

				if (!active) {
					return
				}

				// Promote the deferred src the first time this panel is shown, so
				// the page doesn't open every third-party frame on load.
				var frame = panel.querySelector('iframe[data-ahms-src]')

				if (frame) {
					frame.setAttribute('src', frame.getAttribute('data-ahms-src'))
					frame.removeAttribute('data-ahms-src')
				}
			})

			if (moveFocus) {
				tab.focus()
			}
		}

		tabs.forEach(function (tab, index) {
			tab.addEventListener('click', function () {
				activate(tab, false)
			})

			tab.addEventListener('keydown', function (event) {
				var next = null

				switch (event.key) {
					case 'ArrowRight':
					case 'ArrowDown':
						next = tabs[(index + 1) % tabs.length]
						break
					case 'ArrowLeft':
					case 'ArrowUp':
						next = tabs[(index - 1 + tabs.length) % tabs.length]
						break
					case 'Home':
						next = tabs[0]
						break
					case 'End':
						next = tabs[tabs.length - 1]
						break
					default:
						return
				}

				event.preventDefault()
				activate(next, true)
			})
		})
	}

	/**
	 * Initialize every instance on the page.
	 */
	function init() {
		var blocks = document.querySelectorAll('.epic-scheduling-block--multi')

		Array.prototype.forEach.call(blocks, initBlock)
	}

	if ('loading' !== document.readyState) {
		init()
	} else {
		document.addEventListener('DOMContentLoaded', init)
	}
})()
